import React, { useState } from 'react'
import { MoonLoader } from 'react-spinners'
import { FaSignInAlt } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { loginUser } from '../../redux'
import usePageTitle from '../../hoook/usePageTitle'

function LoginPage({ loginUser, auth }) {
    usePageTitle('- Login')
    const [formData, setFormData] = useState({
        email: '',
        password: '',
    })

    const { email, password } = formData

    const handleOnSubmit = (e) => {
        e.preventDefault()
        loginUser(formData)
    }

    const handleOnChange = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value,
        }))
    }

    return (
        <div className="container">
            <div
                className="d-flex flex-column align-items-center justify-content-center"
                id="form-heading"
            >
                <h1 className="text-white">
                    <FaSignInAlt className="rackemm-text-cyan" /> Login
                </h1>
                <p className="h5 text-white-50 mt-3">Please login</p>
            </div>
            <div className="row d-flex justify-content-center mt-3">
                <div className="col-sm-10 col-md-6 col-lg-4">
                    <div className="card bg-dark border-secondary">
                        <div className="card-body">
                            {auth.loading ? (
                                <div className="d-flex justify-content-center align-content-center">
                                    <MoonLoader size={150} loading />
                                </div>
                            ) : (
                                <form onSubmit={handleOnSubmit}>
                                    <div className="mb-3">
                                        <label
                                            htmlFor="exampleFormControlInput1"
                                            className="form-label text-white-50"
                                        >
                                            Email
                                        </label>
                                        <input
                                            onChange={handleOnChange}
                                            type="email"
                                            name="email"
                                            className="form-control bg-dark text-white border-secondary"
                                            value={email}
                                            placeholder="Enter your email"
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label
                                            htmlFor="exampleFormControlInput1"
                                            className="form-label text-white-50"
                                        >
                                            Password
                                        </label>
                                        <input
                                            onChange={handleOnChange}
                                            type="password"
                                            name="password"
                                            className="form-control bg-dark text-white border-secondary"
                                            value={password}
                                            placeholder="Enter your password"
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <button
                                            type="submit"
                                            className="form-control btn btn-outline-warning"
                                        >
                                            Login
                                        </button>
                                    </div>
                                    <span className="text-white-50">Already have an account?</span>{' '}
                                    <Link
                                        className="rackemm-text-cyan text-decoration-none"
                                        to="/login"
                                    >
                                        Login
                                    </Link>
                                    <br />
                                    <span className="text-white-50">
                                        Forgot your password?
                                    </span>{' '}
                                    <Link
                                        className="rackemm-text-cyan text-decoration-none"
                                        to="/forgot-password"
                                    >
                                        Reset password
                                    </Link>
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    auth: state.auth,
})

const mapDispatchToProps = (dispatch) => ({
    loginUser: (user) => dispatch(loginUser(user)),
})

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage)
